export const meta = {
  id: 'closest-pair',
  name: 'Closest Pair of Points',
  category: 'Geometry',
  complexity: {
    time: 'O(n log n)',
    space: 'O(n)'
  },
  description: 'Closest Pair of Points algorithm finds the pair of points with minimum distance using a divide-and-conquer approach with O(n log n) time complexity.'
};
